import VpnKeyIcon from '@mui/icons-material/VpnKey';
import type { ProviderBrand } from './providerBrand';

interface ProviderLogoProps {
  brand: ProviderBrand;
  /** Edge length in px. */
  size?: number;
}

/**
 * An identity provider's mark, drawn in its own colours. Google's and
 * Microsoft's brand guidelines ask for the full-colour mark on a white or
 * near-black ground, so on a coloured button it sits in a white tile
 * (`SsoProviderButtons`) rather than on the colour itself. Okta's ring and the
 * generic key follow the text colour around them.
 */
export function ProviderLogo({ brand, size = 18 }: ProviderLogoProps) {
  switch (brand) {
    case 'google':
      return (
        <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
        </svg>
      );
    case 'microsoft':
      return (
        <svg width={size * 0.9} height={size * 0.9} viewBox="0 0 22 22" aria-hidden="true" focusable="false">
          <rect x="0" y="0" width="10" height="10" fill="#F25022" />
          <rect x="12" y="0" width="10" height="10" fill="#7FBA00" />
          <rect x="0" y="12" width="10" height="10" fill="#00A4EF" />
          <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
        </svg>
      );
    case 'okta':
      return (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="5" />
        </svg>
      );
    default:
      return <VpnKeyIcon sx={{ fontSize: size + 2 }} aria-hidden="true" />;
  }
}

export default ProviderLogo;
